import { EPricingTabs } from '../Components/Tabs';

export const PRICING_TABS = [
  { label: 'Price Points', value: EPricingTabs.PRICE_POINTS },
  { label: 'Settings', value: EPricingTabs.SETTINGS }
];
